module.exports = __webpack_public_path__ + "static/media/Selo-Direitos-Graviola-Digital.029e1d76.gif";